// components/sections/update/image-update-section/image-update-section.component.jsx

import { useEffect, useState } from 'react';
import Select from 'react-select';

import {
  Container,
  Label,
  Select as NativeSelect,
  Option
} from '../../add/button/button-add-section.styles.jsx';

const linkTypeOptions = [
  { value: 'external', label: 'External' },
  { value: 'internal', label: 'Internal' }
];

const internalPathOptions = [
  { value: '/login', label: 'Login' },
  { value: '/sign-up', label: 'Sign Up' },
  { value: '/shop', label: 'Shop' }
];

const ImageUpdateSection = ({ content = {}, metadata = {}, onChange }) => {
  const [layout, setLayout] = useState(metadata?.layout || 'centered');
  const [linkType, setLinkType] = useState(metadata?.linkType || 'external');
  const [link, setLink] = useState(metadata?.link || '');
  const [isLinkActive, setIsLinkActive] = useState(metadata?.isLinkActive ?? false);
  const [position, setPosition] = useState(metadata?.position || 'center');

  useEffect(() => {
    const finalLink =
      linkType === 'external' && link && !link.startsWith('http')
        ? `https://${link}`
        : link;

    onChange({
      content: { images: content?.images || [] },
      metadata: {
        layout,
        linkType,
        link: finalLink,
        isLinkActive,
        position
      }
    });
  }, [layout, linkType, link, isLinkActive, position]);

  const handleLinkTypeChange = (selected) => {
    setLinkType(selected.value);
    setLink('');
  };

  const handleInternalLinkChange = (selected) => {
    setLink(selected.value);
  };

  return (
    <Container>
      <Label>Layout</Label>
      <NativeSelect value={layout} onChange={(e) => setLayout(e.target.value)}>
        <Option value="centered">Centered</Option>
        <Option value="full-width">Full Width</Option>
      </NativeSelect>

      <Label>Image Position</Label>
      <NativeSelect value={position} onChange={(e) => setPosition(e.target.value)}>
        <Option value="left">Left</Option>
        <Option value="center">Center</Option>
        <Option value="right">Right</Option>
      </NativeSelect>

      <Label>Link Type</Label>
      <Select
        value={linkTypeOptions.find((opt) => opt.value === linkType)}
        onChange={handleLinkTypeChange}
        options={linkTypeOptions}
      />

      <Label>{linkType === 'external' ? 'URL' : 'Internal Path'}</Label>
      {linkType === 'external' ? (
        <input
          type="text"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          placeholder="https://example.com"
        />
      ) : (
        <Select
          value={internalPathOptions.find((opt) => opt.value === link)}
          onChange={handleInternalLinkChange}
          options={internalPathOptions}
        />
      )}

      <Label>
        <input
          type="checkbox"
          checked={isLinkActive}
          onChange={() => setIsLinkActive(!isLinkActive)}
        />
        &nbsp; Link Active
      </Label>
    </Container>
  );
};

export default ImageUpdateSection;